<template>
  <ul class="navigation-menu">
    <li class="navigation-menu-li navigation-menu-li-up navigation-menu-li-active uppercase">
      <router-link class="navigation-menu-li-link" :to="`${checkLang()}${checkPath(theme)}/`">
        <div @click="scrollTo('home')" class="logo-sotbi">
          <svg v-if="!isIE11" width="36" height="26" viewBox="0 0 36 26"><g fill="none" fill-rule="evenodd"><path fill="#23A1D1" d="M32.919 6.729L26.201 0H13.252l9.698 9.716h12.952zM6.563 12.95l7.718-8.925.434-.499-.051-.059-2.426-2.429L11.202 0l-3.48 4.025L0 12.95l7.665 8.861 3.508 4.054 1.065-1.067 2.451-2.456-.458-.531z"/><path fill="#F93" d="M29.937 16.189h-6.989l-9.696 9.715H26.2l6.718-6.728 2.982-2.987z"/></g></svg>
          <img v-else width="36" height="26" src="/static/logo-mini.png"/>
        </div>

      </router-link>
    </li>
    <li :style="`transition-delay: ${(key+1) * .125}s`" :class="`navigation-menu-li uppercase navigation-menu-li-${load ? 'active' : ''}`" v-if="li.full_path !== '/' && li.is_published == 1 && li.is_show_in_menu == 1 && li.parent_id == parent" v-for="li, key in menu">
      <router-link :to="`${checkLang()}${checkPath(theme)}${li.full_path}`"><span @click="scrollTo(li.path)">{{ alternative ? li.name : li.document_name }}</span></router-link>
    </li>
  </ul>
</template>

<script>
import { mapGetters } from 'vuex';
import * as types from '@/store/mutation-types';
import IEDetector from '@/mixins/IEDetector';

export default {
  mixins: [IEDetector],

  computed: mapGetters({
    themeOnlyWhite: 'themeOnlyWhite',
    menu: 'navigation',
    loaded: 'loaded',
    theme: 'theme',
    lang: 'lang',
  }),

  props: ['parent', 'alternative'],

  data() {
    return {
      scrollDuration: 2000,
      load: false,
    };
  },

  methods: {
    checkPath(theme) {
      let path = '';
      if (theme === 'dark') {
        path = '/dark';
      } else if (this.themeOnlyWhite) {
        path = '/white';
      }
      return path;
    },

    scrollTo(page) {
      this.$store.commit(types.ENABLE_ALL_VISIBILITY, true);
      setTimeout(() => {
        this.$store.commit(types.ENABLE_ALL_VISIBILITY);
      }, 2500);
      this.$SmoothScroll(window.Sotbi.$children[0].$refs[page], this.scrollDuration);
    },

    checkLang() {
      return this.lang === 0 ? '' : '/eng';
    },

    checkPathname() {
      const currentPath = window.location.pathname;
      if (currentPath.length > 1) {
        const darkPart = 'dark';
        let pathChapter = currentPath.replace(/\//g, '');
        if (pathChapter.indexOf(darkPart) > -1) {
          this.$store.dispatch('changeTheme', 'dark');
          pathChapter = pathChapter.replace(darkPart, '');
        } else {
          const whitePart = 'white';
          pathChapter = pathChapter.replace(whitePart, '');
        }
        pathChapter = pathChapter.replace('eng', '');
        if (pathChapter !== '') {
          this.scrollTo(pathChapter);
        }
      }
    },
  },

  watch: {
    loaded() {
      this.checkPathname();
      setTimeout(() => {
        this.load = true;
      }, 1500);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.navigation{
  &-menu{
    -webkit-padding-start: 0;
    -webkit-margin-before: 0;
    display: inline-block;
    list-style-type: none;
    margin: 3px -3px;
    font-size: 90%;

    &-li{
      transition: all .5s ease-in-out;
      transform: translate3d(0,-30px,0);
      display: inline-block;
      margin-bottom: 0;
      margin-right: 20px;
      opacity: 0;

      &-link{
        display: inline-block;
      }

      &-up{
        display: none;

        .header-fixed &{
          display: inline-block;
        }

        @media (min-width: $mediaMob) {
          margin-left: -23px;
        } 

        .app-low & {
          display: none;
        }

        @media (max-width: $mediaMini) {
          position: relative;
          margin-left: 20px;
          top: 5px;
        }
      }

      @media (max-width: $mediaMini) {
        margin-bottom: 5px;
      }

      &:before{
        display: none;
      }

      &-active{
        transform: translate3d(0,0,0);
        opacity: 1;
      }
    }

    &-lang{
      margin-right: 5px;
      a{
        cursor: pointer;
      }

      &-active{
        border-bottom: 0;
        a{
          cursor: text;
          &:hover{
            color: black;
          }
        }
      }
    }

  }

  &-title{
    position: relative;
    z-index: 99;
    top: 50px;
    ul{
      margin: 0;
    }
  }

  .logo-sotbi{
    transition: .3s ease-in-out all;
    position: absolute;
    height: 26px;
    left: -25px;
    top: -6px;

    @media (max-width: $mediaMini) {
      left: -20px;
      top: -10px;
    }

    img,
    svg{
      height: 26px;
      width: 25px;
    }

    &:hover{
      transform: scale(1.1);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NavigationMenu.vue